import './App.css';
import Navigation from './main/navigation';

function App() {
  return (
    <Navigation />
  )
}

export default App